import React from 'react';
import PlacesAutoComplete from 'Components/PlacesAutoComplete';
import { ReactComponent as AddIcon } from "Icons/new-plus.svg";
import { ReactComponent as DeleteIcon } from "Icons/delete.svg";
import Input from 'Components/Input';
import Dropdown from 'Components/Dropdown/dropdown';
import Cx from 'classnames';
import ResponsiveTable from 'Components/ResponsiveTable/index';
const VARIABLE_CHARGES = [
    {name: 'Additional KM Freight', id: 1},
    {name: 'Handling Charges', id: 2},
    {name: 'Other Handling Charges', id: 3}
]


const emamiDedicatedContract = (props) => {
    const { onChangeTrips, isView, onChangeDedicatedVC, trip, tripIndex, vehicleTypes, pricingBasis } = props;
    const symbolsArr = ["e", "E", "+", "-", "."];

    const getVariableCharges = () => {
        const variableChargesFields = (trip.dedicated_variable_cost || []).map(el => el.variable_charges) || []
        return (VARIABLE_CHARGES || []).filter(el => !variableChargesFields.includes(el.name));
    }

    return (
        <>
            <div className={Cx('', {
                'disable-pointer-events': isView
            })}> 
                {/* <ResponsiveTable> */}
                    <div className='flex col-1'>
                        <div className='content-bgColor pv-5 ph-10 mt-5 br-2 mr-20 inBlock col-2'>
                            <table className='trip-table-secondary' cellspacing={'10px'}>
                                <tr>
                                    <th>Fixed Cost</th>
                                    <th>Pricing Basis</th>
                                    <th>Vehicle Type</th>
                                    <th>Minimum Km</th>
                                </tr>
                                <tr>
                                    <td>
                                        <Input 
                                            className={'border-dblue br-2 wt-100'}
                                            placeholder={'Fixed Cost'}                                            
                                            value={trip.fixed_cost}
                                            onKeyDown={e => (["e", "E", "+", "-"].includes(e.key)) && e.preventDefault()}
                                            onChange={(e) => onChangeTrips(tripIndex, 'fixed_cost', e)}
                                            type={'number'}
                                        />
                                    </td>
                                    <td className={Cx('', {'disable-pointer-events': isView})}>
                                        <div className='flex'>
                                            <Dropdown 
                                                items={(pricingBasis || []).filter(el => ((el.name || '').toLowerCase()).includes('month'))}
                                                displayKey={"name"}
                                                widthValue={'150px'}
                                                className="border-dblue bg-white"
                                                name="pricing_basis" 
                                                label="Select"
                                                selectedItem={trip.pricing_basis && pricingBasis.find(el => el.name == trip.pricing_basis)}
                                                onSelect={(optionValue) => onChangeTrips(tripIndex, 'pricing_basis', pricingBasis.find(el => el.name == optionValue))}
                                            />
                                        </div>
                                    </td>
                                    <td>
                                        <Dropdown 
                                            items={vehicleTypes}
                                            displayKey={"name"}
                                            widthValue={'180px'}
                                            className="border-dblue bg-white"
                                            name="vehicle_type_id" 
                                            label="Select"
                                            selectedItem={trip.vehicle_type_id && vehicleTypes.find(el => el.value == trip.vehicle_type_id)}
                                            onSelect={(optionValue) => onChangeTrips(tripIndex, 'vehicle_type_id', vehicleTypes.find(el => el.name == optionValue))}
                                        />
                                    </td>
                                    <td>
                                        <Input  
                                            className={'border-dblue br-2 mr-5'}
                                            style={{'width': '90px'}}
                                            type={'number'}
                                            placeholder={'Minimum Km'}
                                            value={trip.minimum_km}
                                            onKeyDown={e => (symbolsArr.includes(e.key)) && e.preventDefault()}
                                            onChange={(e) => onChangeTrips(tripIndex, 'minimum_km', e)}
                                        />
                                    </td>
                                </tr>
                            </table>
                        </div>
                    
                        <div className='content-bgColor pv-5 ph-10 mt-5 br-2 mr-10 inBlock col-2'>
                            <table className='trip-table-secondary' cellspacing={'10px'}>
                                <tr>
                                    <th>Variable Charges </th>
                                    <th>Variable Cost</th>
                                    <th>Pricing Basis</th>
                                    {!isView && <th></th>}
                                </tr>
                                {(trip.dedicated_variable_cost || []).map((dedicatedCost, dedicatedIndex) => {
                                    let pricingbasislist = pricingBasis || [];
                                    if((dedicatedCost.variable_charges || '').toLowerCase().includes('km')) {
                                        pricingbasislist = pricingBasis.filter(el => ((el.name || '').toLowerCase()).includes('km'));
                                    } else if(dedicatedCost.variable_charges) {
                                        pricingbasislist = pricingBasis.filter(el => ((el.name || '').toLowerCase()).includes('trip'));
                                    }

                                    return(<tr>
                                            <td className={Cx('', {'disable-pointer-events': isView})}>
                                                <Dropdown 
                                                    className="border-dblue bg-white"
                                                    widthValue={'200px'}
                                                    items={getVariableCharges()}
                                                    name="variable_charges" 
                                                    displayKey="name" 
                                                    label="Select"
                                                    selectedItem={dedicatedCost.variable_charges && VARIABLE_CHARGES.find(el => el.name == dedicatedCost.variable_charges)}
                                                    onSelect={(optionValue) => {
                                                        onChangeDedicatedVC(tripIndex, 'variable_charges', optionValue, dedicatedIndex)
                                                    }}
                                                    id={"variable_charges"}
                                                />
                                            </td>

                                            <td className={Cx('', {'disable-pointer-events': isView})}>
                                                <Input 
                                                    className={'border-dblue br-2 wt-100'}
                                                    type={'number'}
                                                    placeholder={'Variable Cost'}
                                                    onKeyDown={e => (["e", "E", "+", "-"].includes(e.key)) && e.preventDefault()}
                                                    value={dedicatedCost.variable_cost}
                                                    onChange={(e) => onChangeDedicatedVC(tripIndex, 'variable_cost', e, dedicatedIndex)}
                                                />
                                            </td>
                                            <td className={Cx('', {'disable-pointer-events': isView})}>
                                                <Dropdown 
                                                    items={pricingbasislist.length > 0 ? pricingbasislist : pricingBasis}
                                                    displayKey={"name"}
                                                    widthValue={'150px'}
                                                    className="border-dblue bg-white"
                                                    name="pricing_basis" 
                                                    label="Select"
                                                    selectedItem={dedicatedCost.pricing_basis && pricingBasis.find(el => el.name == dedicatedCost.pricing_basis)}
                                                    onSelect={(optionValue) => onChangeDedicatedVC(tripIndex, 'pricing_basis', pricingBasis.find(el => el.name == optionValue), dedicatedIndex)}
                                                />
                                            </td>
                                            {!isView &&<td>
                                                <div className='flex'>
                                                    {(trip.dedicated_variable_cost || []).length > 1 && <DeleteIcon className='wt-18 ht-18 mr-5 curP fBold' onClick={() => props.onDeleteDedicatedVC(tripIndex, dedicatedIndex)}/>}
                                                    <AddIcon className='curP' onClick={() => props.onAddDedicatedVC(tripIndex)}/>
                                                </div>
                                            </td>}
                                    </tr>)
                                })}
                            </table>
                        </div>
                    </div>
                {/* </ResponsiveTable> */}
            </div>
        </>
    )
}

export default emamiDedicatedContract;
